// Версия клиента в запросах и ответ сервера «обновитесь».
//
// Плагин подключает HTTP-клиент приложения (`plugins` `createApiClient` из `@srm/core/http`): форма — та же, что у
// `ApiPlugin` клиента (`name`, `request(ctx)` дописывает заголовки в `ctx.headers` — и для axios, и для keepalive;
// `response(response, outcome)` — на любой ответ сервера, и успех, и отказ). Типы — свои структурные: `/version` не
// зависит от `/http`.

import { readHeader } from '../errors/index';

/** Версия сборки в каждом запросе: по ней сервер пишет в журнал, с какого фронта пришёл запрос. */
export const CLIENT_VERSION_HEADER = 'X-Client-Version';

/** Ответ сервера «эту версию клиента больше не принимаем» (`ClientVersion:MinFrontVersion` в WebAPI). */
export const CLIENT_UPDATE_HEADER = 'x-client-update';

/** Сервер потребовал обновиться (`x-client-update: required`); без ответа (сеть) — нет. */
export const isClientUpdateRequired = (response: { headers?: unknown } | undefined): boolean =>
    readHeader(response?.headers, CLIENT_UPDATE_HEADER) === 'required';

/** Запрос глазами плагина: заголовки, которые уйдут с ним. */
export interface IClientVersionRequest {
    readonly headers: Record<string, string>;
}

/** Ответ глазами плагина: заголовки AxiosHeaders или простой объект. */
export interface IClientVersionResponse {
    readonly headers?: unknown;
}

export interface IClientVersionPlugin {
    readonly name: 'client-version';
    request(ctx: IClientVersionRequest): void;
    response(response: IClientVersionResponse | undefined, outcome?: 'success' | 'error'): void;
}

export interface IClientVersionPluginOptions {
    /** Версия сборки приложения (`__APP_VERSION__`, в dev — `'dev'`). */
    version: string;
    /** Сервер не принимает эту версию — обычно `require` экземпляра `createVersionUpdate`. */
    onUpdateRequired: () => void;
}

export function clientVersionPlugin({ version, onUpdateRequired }: IClientVersionPluginOptions): IClientVersionPlugin {
    return {
        name: 'client-version',
        request(ctx) {
            ctx.headers[CLIENT_VERSION_HEADER] = version;
        },
        response(response) {
            if (isClientUpdateRequired(response)) onUpdateRequired();
        },
    };
}
